export const BREAKPOINT_DESKTOP_MIN = '1200px'
export const BREAKPOINT_TABLET_MAX = '1199px'
export const BREAKPOINT_TABLET_MIN = '810px'
export const BREAKPOINT_PHONE_MAX = '809px'
export const BREAKPOINT_PHONE_MIN = '390px'
export const BREAKPOINT_SMALL_MAX = '389px'
